export const EXTERNAL_INCOMES = [
    {
        transKey: 'FINANCING.EMPLOYMENT_INFOS.OTHER_INCOME_TYPES.CAR_ALLOWANCE',
        value: 'carAllowance',
    },
    {
        transKey: 'FINANCING.EMPLOYMENT_INFOS.OTHER_INCOME_TYPES.CHILD_SUPPORT_ALIMONY',
        value: 'childSupportAlimony',
    },
    {
        transKey: 'FINANCING.EMPLOYMENT_INFOS.OTHER_INCOME_TYPES.DISABILITY_PAYMENTS',
        value: 'disabilityPayments',
    },
    {
        transKey: 'FINANCING.EMPLOYMENT_INFOS.OTHER_INCOME_TYPES.INVESTMENT_INCOME',
        value: 'investmentIncome',
    },
    {
        transKey: 'FINANCING.EMPLOYMENT_INFOS.OTHER_INCOME_TYPES.PENSIONS',
        value: 'pensions',
    },
    {
        transKey: 'FINANCING.EMPLOYMENT_INFOS.OTHER_INCOME_TYPES.RENTAL_INCOME',
        value: 'rentalIncome',
    },
    {
        transKey: 'FINANCING.EMPLOYMENT_INFOS.OTHER_INCOME_TYPES.WORKERS_COMPENSATION',
        value: 'workersCompensation',
    },
    {
        transKey: 'FINANCING.EMPLOYMENT_INFOS.OTHER_INCOME_TYPES.OTHER',
        value: 'other',
    },
];

export default {
    EXTERNAL_INCOMES,
};
